// extracted by mini-css-extract-plugin
module.exports =  {"header":"da51a739f7--header--19hXg","logo":"da51a739f7--logo--IU8P3","title":"da51a739f7--title--ySgoJ"};